__turbopack_context__.v({
  "aspectSpacer": "styles-module__6lTz7W__aspectSpacer",
  "cardColumn": "styles-module__6lTz7W__cardColumn",
  "cardOverlay": "styles-module__6lTz7W__cardOverlay",
  "engineCopyIn": "styles-module__6lTz7W__engineCopyIn",
  "engineCopyOut": "styles-module__6lTz7W__engineCopyOut",
  "engineMediaMotionIn": "styles-module__6lTz7W__engineMediaMotionIn",
  "layoutSpacer": "styles-module__6lTz7W__layoutSpacer",
  "logoMotion": "styles-module__6lTz7W__logoMotion",
  "mediaFrame": "styles-module__6lTz7W__mediaFrame",
  "mediaMotion": "styles-module__6lTz7W__mediaMotion",
  "mediaScrim": "styles-module__6lTz7W__mediaScrim",
  "mediaStage": "styles-module__6lTz7W__mediaStage",
  "paletteBlack": "styles-module__6lTz7W__paletteBlack",
  "paletteBlue": "styles-module__6lTz7W__paletteBlue",
  "paletteLime": "styles-module__6lTz7W__paletteLime",
  "paletteOrange": "styles-module__6lTz7W__paletteOrange",
  "remarkItem": "styles-module__6lTz7W__remarkItem",
  "remarkItemActive": "styles-module__6lTz7W__remarkItemActive",
  "remarkStack": "styles-module__6lTz7W__remarkStack",
  "root": "styles-module__6lTz7W__root",
  "stageFill": "styles-module__6lTz7W__stageFill",
  "switchStack": "styles-module__6lTz7W__switchStack",
});
